export var valuesPushNotificationSetting = ["Creator", "ResponsiblesAndMentioned", "AllGroupUsers", "GroupAdmins"];
/*

*/ 
//# sourceMappingURL=PushNotificationSetting.js.map